import { render, staticRenderFns } from "./LanguageSwitch.vue?vue&type=template&id=ba48de04&"
import script from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
export * from "./LanguageSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./LanguageSwitch.vue?vue&type=style&index=0&id=ba48de04&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports